export default __webpack_public_path__ + "img/ejavjNUy.3f86c806.svg";